import React from "react";
import { Stack } from "expo-router";
import Constants from "expo-constants";
import { Colors } from "@/constants/Colors";
import useWindow from "@/hooks/useWindow";
import { isWeb } from "@/utils/platform";

const AccountLayout = () => {
  const { isDesktop } = useWindow();
  return (
    <Stack
      screenOptions={{
        contentStyle: {
          paddingTop: Constants.statusBarHeight,
          backgroundColor: Colors.background,
          width: isDesktop ? 600 : undefined,
          alignSelf: isDesktop ? "center" : undefined,
        },
      }}
    >
      <Stack.Screen name="profile" options={{ headerShown: false }} />
      <Stack.Screen name="delete" options={{ headerShown: false }} />
      <Stack.Screen name="cancel" options={{ headerShown: false }} />
      <Stack.Screen
        name="resubscribe-success"
        options={{ headerShown: false }}
      />
      <Stack.Screen name="linked-banks" options={{ headerShown: false }} />
      <Stack.Screen name="linked-emails" options={{ headerShown: false }} />
      <Stack.Screen name="bill-items/index" options={{ headerShown: false }} />
      <Stack.Screen name="payment" options={{ headerShown: false }} />
      {isWeb && (
        <Stack.Screen name="add-card" options={{ headerShown: false }} />
      )}
    </Stack>
  );
};

export default AccountLayout;
